import { getLogger } from '../tracking/felog/telemetry'
import { RecaptchaConfig, ReCaptchaInstanceEnterprise } from '../types'

export const recaptchaOnLoadFnName = 'captchaOnLoad'

const getCaptchaScriptElement = () => {
  return document.querySelector('script[data-key="captcha"]')
}

const onCaptchaLoad = () => {
  getLogger('cms.recaptcha').info('Initial Captcha load time ', {
    loadTime: Date.now() - initTimeStart,
  })
}

let isInitialized = false
let initTimeStart = 0

export const isSSR = () => !IS_CLIENT_SIDE && typeof window === 'undefined'

export const init = () => {
  if (isSSR() || isInitialized) {
    return
  }

  initTimeStart = Date.now()
  getLogger('cms.recaptcha').info('Initializing reCAPTCHA ', {
    initTime: initTimeStart,
  })

  window[recaptchaOnLoadFnName] = onCaptchaLoad
  isInitialized = true
}

export const getSrcUrl = (recaptchaConfig: RecaptchaConfig) => {
  const url = recaptchaConfig.urls.original
  const siteKey = recaptchaConfig.siteKey

  return `${url}?render=${encodeURIComponent(siteKey)}&logging=true&onload=${encodeURIComponent(recaptchaOnLoadFnName)}`
}

export const isReCaptchaScriptLoaded = () => {
  if (isSSR()) {
    return false
  }
  return !!getCaptchaScriptElement()
}

export const grecaptcha = (): ReCaptchaInstanceEnterprise | undefined => {
  if (isSSR()) {
    return undefined
  }

  return window.grecaptcha as ReCaptchaInstanceEnterprise | undefined
}

export const waitTillReCaptchaReady = (maxWaitTime = 10000) => {
  if (isSSR()) {
    return Promise.reject(new Error('This function should only be called on the client side.'))
  }
  const start = Date.now()
  let timeoutId: number | undefined

  return new Promise((resolve, reject) => {
    const check = () => {
      const timeTook = Date.now() - start

      if (timeTook > maxWaitTime) {
        clearTimeout(timeoutId)
        return reject(new Error(`Max wait time of ${maxWaitTime}ms reached while waiting for grecaptcha to fully load`))
      }

      if (window.grecaptcha?.enterprise) {
        window.grecaptcha.enterprise.ready(() => {
          clearTimeout(timeoutId)
          resolve(timeTook)
        })
      } else {
        timeoutId = window.setTimeout(check, 100)
      }
    }

    check()
  })
}
